/**
 * @fileoverview Configuration for what tags are allowed in RichFormattedMessage.
 */

import React, { ReactNode } from 'react';

export const RICH_TAGS = {
  br: <br />,
  strong: (...chunks: ReactNode[]) =>
    chunks.map((e, i) => <strong key={i}>{e}</strong>),
  ul: (...chunks: ReactNode[]) => chunks.map((e, i) => <ul key={i}>{e}</ul>),
  li: (...chunks: ReactNode[]) => chunks.map((e, i) => <li key={i}>{e}</li>),
  em: (...chunks: ReactNode[]) => chunks.map((e, i) => <em key={i}>{e}</em>),
};
